<template>
    <div>
        <van-nav-bar :fixed="true" left-arrow left-text="返回" @click-left="onClickLeftBack"></van-nav-bar>
        <div style="width: 100%;height:50px;"></div>
        <div class="list-view" :style="{ height: screenHeight }">
            <div class="ql-editor" v-html="videoData.content"></div>
        
        </div>
        <!-- <div class="kuang">
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
                <div class="bubble"></div>
            </div> -->
    </div>
</template>

<script>
export default {
    name: 'VideoContentMobile',
    components: {

    },
    data() {
        return {
            // 屏幕宽度
            screenWidth: window.screen.width,
            // 屏幕高度
            screenHeight: (window.screen.height - 140) + "px",
            content: "",
            videoData: '',
        }
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.videoData = this.$route.params.data
            let content = this.videoData.content
            // 删除宽度和高度属性的正则表达式
            var widthHeightRegex = /width="[^"]*"\s*height="[^"]*"\s*/g;

            // 使用正则表达式替换来删除宽度和高度属性
            var c1 = content.replace(widthHeightRegex, '');
            let c2 = c1.replace(/<img width="100%"/g, '<img');
            let c3 = c2.replace(/<img/g, '<img width="100%"');

            // console.log(c3);
            this.videoData.content = c3;

        },
        onClickLeftBack() {
            this.$router.back()
        },
    },
    created() {
        console.log(this.$route.params.data);
        this.getDataList()
    },

}
</script>

<style lang="less" scoped>
.van-nav-bar {
    background-color: #00000000;
}
/* 需要滚动条隐藏的列表 */
.list-view {
    width: 100%;
    // height: 700px;
    margin-top: 30px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}
</style>